import React from 'react';

function MusicShow(props) {
    return (
        <div>
            {props.musicName}
        </div>
    );
}

export default MusicShow;